import { render } from "./CommonEmailSendMessageForm.vue?vue&type=template&id=c6fb96e8&scoped=true"
import script from "./CommonEmailSendMessageForm.vue?vue&type=script&lang=js"
export * from "./CommonEmailSendMessageForm.vue?vue&type=script&lang=js"

import "./CommonEmailSendMessageForm.vue?vue&type=style&index=0&id=c6fb96e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6fb96e8"]])

export default __exports__